import React from 'react';
import { Link } from "react-router-dom";
import Logo from '../../../../Assets/Images/logo.png'
import Divider from '@mui/material/Divider';
import PodcastsRoundedIcon from '@mui/icons-material/PodcastsRounded';
import LibraryMusicOutlinedIcon from '@mui/icons-material/LibraryMusicOutlined';
import AutoStoriesOutlinedIcon from '@mui/icons-material/AutoStoriesOutlined';
import QueueMusicOutlinedIcon from '@mui/icons-material/QueueMusicOutlined';
import MicNoneIcon from '@mui/icons-material/MicNone';

export default function Sidebar() {
    return (
        <aside className='hidden bg-white shadow-xl lg:flex flex-col px-4 fixed h-full w-[200px] top-0 right-0 z-20 text-sm'>
            <a href="#" className='flex justify-center'>
                <img src={Logo} alt='logo' className='w-[6rem]'/>
            </a>
            <div className="flex flex-col space-y-4">
                <Link to='/'>
                    <div className="flex flex-row items-center">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5}
                             stroke="currentColor" className="w-5 h-5 ml-1">
                            <path strokeLinecap="round" strokeLinejoin="round"
                                  d="M2.25 12l8.954-8.955c.44-.439 1.152-.439 1.591 0L21.75 12M4.5 9.75v10.125c0 .621.504 1.125 1.125 1.125H9.75v-4.875c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21h4.125c.621 0 1.125-.504 1.125-1.125V9.75M8.25 21h8.25"/>
                        </svg>

                        <div className='text-md font-normal'>خانه</div>
                    </div>
                </Link>
                <Link to='/'>
                    <div className="flex flex-row items-center">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5}
                             stroke="currentColor" className="w-5 h-5 ml-1">
                            <path strokeLinecap="round" strokeLinejoin="round"
                                  d="M6 6.878V6a2.25 2.25 0 012.25-2.25h7.5A2.25 2.25 0 0118 6v.878m-12 0c.235-.083.487-.128.75-.128h10.5c.263 0 .515.045.75.128m-12 0A2.25 2.25 0 004.5 9v.878m13.5-3A2.25 2.25 0 0119.5 9v.878m0 0a2.246 2.246 0 00-.75-.128H5.25c-.263 0-.515.045-.75.128m15 0A2.25 2.25 0 0121 12v6a2.25 2.25 0 01-2.25 2.25H5.25A2.25 2.25 0 013 18v-6c0-.98.626-1.813 1.5-2.122"/>
                        </svg>
                        <div className='text-md font-normal'>مرورگر</div>
                    </div>
                </Link>
                <Link to='search'>
                    <div className="flex flex-row items-center">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5}
                             stroke="currentColor" className="w-5 h-5 ml-1">
                            <path strokeLinecap="round" strokeLinejoin="round"
                                  d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z"/>
                        </svg>

                        <div className='text-md font-normal'>جستجو</div>
                    </div>
                </Link>
                <Divider variant="middle"/>
                <Link to={'browse'} state={{title: 'موسیقی'}}>
                    <div className="flex flex-row items-center">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-5 h-5 ml-2">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M9 9l10.5-3m0 6.553v3.75a2.25 2.25 0 01-1.632 2.163l-1.32.377a1.803 1.803 0 11-.99-3.467l2.31-.66a2.25 2.25 0 001.632-2.163zm0 0V2.25L9 5.25v10.303m0 0v3.75a2.25 2.25 0 01-1.632 2.163l-1.32.377a1.803 1.803 0 01-.99-3.467l2.31-.66A2.25 2.25 0 009 15.553z" />
                        </svg>
                        <div className='text-md font-normal'>موسیقی</div>
                    </div>
                </Link>
                <Link to={'browse'} state={{title: 'هنرمند'}}>
                    <div className="flex flex-row items-center">
                        <MicNoneIcon className='ml-2'/>
                        <div className='text-md font-normal'>هنرمند</div>
                    </div>
                </Link>
                <Link to={'browse'} state={{title: 'آلبوم'}}>
                    <div className="flex flex-row items-center">
                        <LibraryMusicOutlinedIcon className='ml-2'/>
                        <div className='text-md font-normal'>آلبوم</div>
                    </div>
                </Link>
                <Link to={'browse'} state={{title: 'پادکست'}}>
                    <div className="flex flex-row items-center">
                        <PodcastsRoundedIcon className='ml-2'/>
                        <div className='text-md font-normal'>پادکست</div>
                    </div>
                </Link>
                <Link to={'browse'} state={{title: 'کتاب صوتی'}}>
                    <div className="flex flex-row items-center">
                        <AutoStoriesOutlinedIcon className='ml-2'/>
                        <div className='text-md font-normal'>کتاب صوتی</div>
                    </div>
                </Link>
                <Link to={'browse'} state={{title: 'پلی لیست ها'}}>
                    <div className="flex flex-row items-center">
                        <QueueMusicOutlinedIcon className='ml-2'/>
                        <div className='text-md font-normal'>پلی لیست ها</div>
                    </div>
                </Link>

            </div>
        </aside>
    );
}